/** Agent runtime sélectionnable (canary). */
export type AssistantAgentId = 'laika' | 'spoutnik' | 'compare';

const STORAGE_KEY = 'rintintin:assistant-agent';

export function readStoredAssistantAgent(): AssistantAgentId {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'spoutnik' || v === 'laika' || v === 'compare') return v;
  } catch {
    /* ignore */
  }
  return 'compare';
}

export function writeStoredAssistantAgent(agent: AssistantAgentId): void {
  try {
    localStorage.setItem(STORAGE_KEY, agent);
  } catch {
    /* ignore */
  }
}

const DEFAULT_SPOUTNIK_API_URL = 'https://spoutnik-production.up.railway.app';

export function resolveSpoutnikChatUrl(): string | null {
  const raw = (process.env.REACT_APP_SPOUTNIK_API_URL || DEFAULT_SPOUTNIK_API_URL)
    .trim()
    .replace(/\/$/, '');
  if (!raw) return null;
  if (raw.endsWith('/v1/chat')) return raw;
  return `${raw}/v1/chat`;
}

/** URL API chat Laika (Railway / override env). */
export function resolveLaikaChatUrl(): string {
  return (
    process.env.REACT_APP_LAIKA_API_URL ||
    'https://laika-v3-production.up.railway.app/api/chat/v3'
  );
}
